export default __webpack_public_path__ + "static/FeatureJungle-Light-4f6a8814c5ee9a3ad2afee78df563693.woff2";